<template>
  <div class="w-full pt-6">
    <ItemEditTabView v-model:model-value="activeTab"></ItemEditTabView>
    <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 pt-4">
      <PirateCard
        type="item"
        :pirate="item"
        v-for="(item, key) in currentComponentData"
        @click="openItemDetailDrawer(item)"
      ></PirateCard>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import ItemEditTabView from '../ItemEditTabView.vue'
import PirateCard from '../PirateCard.vue'
import ItemDetailDrawer from '../drawers/ItemDetailDrawer.vue'
import { useConstantStore } from '@/stores/constant'

const constantStore = useConstantStore()

const tabList = ref(['sword', 'hat', 'shirt', 'pants', 'shoes', 'belt'])
const activeTab = ref(0)

const openItemDetailDrawer = (itemInfo) => {
  openBottomDrawer(ItemDetailDrawer, {
    props: { itemInfo: itemInfo },
    emits: {},
    size: 'md',
  })
}

const currentComponentData = computed(() => {
  const activeTabName = tabList.value[activeTab.value]
  return constantStore.skins.filter((e) => e.type === activeTabName)
})
</script>
